const Request = require('./BaseRequest')
const ContactGraph = require('../graph/ContactGraph')

module.exports = class ContactRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new ContactGraph(this.apiDomain)
    }

    swrAccount(contactId, useSwr = true)
    {
        let args = {contactId: contactId}
        let { type, query } = this.graph.accountQuery(['id', 'contactId', 'contact_id', 'user_id',
            { contact: ['email', 'mobile_number', 
                {profile:['firstname', 'lastname', 'password_hash', 'street', 'city', 'zip_code', 'province_id', 'country_id', 'phone_number','image','country_code']},
                {socialSpace:['facebook', 'twitter', 'linkedin', 'pinterest', 'facebook_page', 'facebook_profile', 'personal_metadata', 'instagram_metadata']},
                {miscellaneous:['family','hobbies_n_interest','occupation','data']}
            ]}
        ], args)

        if (useSwr) return this.graph.swrRequest(query, this.swrOptions, type)
        return this.graph.request(query, args, type)
    }

    swrContact(email, useSwr = true)
    {
        let args = {email: email}
        let { type, query } = this.graph.contactQuery(['id', 'email', {
                account: ['contactId']
            }], args)
        if (useSwr) return this.graph.swrRequest(query, this.swrOptions, type)
        return this.graph.request(query, args, type)
    }

    async updateAddressProfile(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.updateAdressProfile(['contact_id', 'street','city', 'zip_code', 'province_id', 'country_id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async updateContactProfile(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.updateContactProfile(['contact_id', 'firstname','lastname', 'mobile', 'phone_number', 'mobileCountryCode', 'phoneNumberCountryCode'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async updateSocialSpaces(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.updateSocialSpaces(['contact_id', 'facebook', 'twitter', 'linkedin', 'pinterest', 'instagram_metadata', 'personal_metadata'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async updateLoginDetails(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.updateLoginDetails(['contact_id', 'email', 'password'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async updateMisc(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.updateMisc(['contact_id', 'family', 'occupation', 'hobbies_n_interest', 'data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async unsubscribeContact(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.unsubscribeContact(['id', 'is_subscribed', 'is_unsubscribed'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }


    async addExploreModule(contact_id=null, module, key, content_id, value, user_id=null)
    {
        let args = {contact_id: contact_id, module: module, key: key, content_id: content_id, value: value, user_id: user_id}
        let { type, query } = this.graph.addExploreModule(['id', 'created_at'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrExploreModule(contact_id=null, user_id=null)
    {
        let args = {contact_id: contact_id, user_id: user_id}
        let { type, query } = this.graph.exploreModuleQuery(['id', 'contact_id', 'user_id', 'misc_data', 'created_at'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async uploadAvatar(contact_id, image)
    {
        let args = {contact_id: contact_id, image: image}
        let { type, query } = this.graph.uploadAvatar(['image', 'updated_at'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    //  Smart Start
    async smartStart(contact_id, value, date_completed, other_data = null)
    {
        let args = { contact_id: contact_id, value: value, date_completed: date_completed, other_data: other_data }
        let { type, query } = this.graph.smartStartMutation(['data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    //  Smart Start
    async register(first_name, last_name, email, phone, street, cityTown, stateProvince, zipPostal, tag, list_id)
    {
        let args = { first_name: first_name, last_name: last_name, email: email, phone: phone, street:street, cityTown:cityTown, stateProvince:stateProvince, zipPostal:zipPostal, tag:tag, list_id:list_id }
        let { type, query } = this.graph.registerMutation(['first_name','last_name'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrSmartStartQuery(contact_id, name)
    {
        let args = { contact_id: contact_id, name: name }
        let { type, query } = this.graph.smartStartQuery(['data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSmartStartAllQuery(contact_id) 
    {
        let args = { contact_id: contact_id }
        let { type, query } = this.graph.smartStartAllQuery(['data'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}